export const odinFaq = [
  {
    id: 'faq-adjacency',
    question: 'Czy dwa czerwone kafle mogą stykać się rogami?',
    answer:
      'Tak. Zakaz dotyczy bezpośredniego stykania bokami na planszach przestrzennych. Styk narożnikami jest dozwolony. Zielone i niebieskie nie mają tego ograniczenia.',
    requiredModuleIds: ['base'],
    keywords: ['czerwone', 'pomarańczowe', 'sąsiedztwo'],
  },
  {
    id: 'faq-flip',
    question: 'Czy mogę odwrócić kafel podczas układania?',
    answer:
      'Nie. Możesz zmienić orientację przestrzenną (obrót), ale odwrócenie na drugą stronę wymaga efektu ulepszenia dobra. Odwracasz ten sam żeton — nie bierzesz innego z puli.',
    requiredModuleIds: ['base'],
  },
  {
    id: 'faq-move',
    question: 'Czy można później przesuwać położone kafle?',
    answer:
      'Zasadniczo nie. Położenie jest trwałe, chyba że konkretny efekt wyraźnie pozwala dokonać zmiany.',
    requiredModuleIds: ['base'],
  },
  {
    id: 'faq-bonus-now',
    question: 'Czy premię dostaję natychmiast po jej otoczeniu?',
    answer:
      'Nie. Standardowo pobierasz ją w fazie premii. Symbol musi być otoczony i pozostać odkryty.',
    requiredModuleIds: ['base'],
  },
  {
    id: 'faq-income-cover',
    question: 'Czy zakrywam pole dochodu, aby je otrzymać?',
    answer:
      'Nie. Symbol dochodu pozostaje widoczny. Zakrywasz wymagany obszar prowadzący do niego bez luk, które urywają linię.',
    requiredModuleIds: ['base'],
  },
  {
    id: 'faq-partial-action',
    question: 'Czy mogę wykonać tylko część pola akcji?',
    answer:
      'Opcjonalne części rozpoznasz po symbolach wyboru lub sformułowaniu „możesz”. Połączone obowiązkowe koszty i efekty wykonujesz w całości. Nie można wybrać pola, jeśli nie da się opłacić obowiązkowego kosztu.',
    requiredModuleIds: ['base'],
  },
  {
    id: 'faq-hunt-resources',
    question: 'Czy przy każdym polowaniu mogę używać drewna?',
    answer:
      'Nie. Używasz tylko modyfikatorów pokazanych na konkretnym polu. Łowienie ryb i polowanie na łosia z Norwegów nie pozwalają używać drewna.',
    requiredModuleIds: ['base'],
  },
  {
    id: 'faq-special-token',
    question: 'Czy po rzucie muszę wziąć żeton specjalny o dokładnie tej wartości?',
    answer:
      'Nie. Możesz wybrać dostępny żeton o wartości miecza równej lub niższej od osiągniętego wyniku.',
    requiredModuleIds: ['base'],
  },
  {
    id: 'faq-ship-repeat',
    question: 'Czy jedna łódź może być używana wielokrotnie?',
    answer:
      'Tak, dopóki akcja jej nie usuwa. Emigracja i niektóre specjalne użycia usuwają łódź na stałe.',
    requiredModuleIds: ['base'],
  },
  {
    id: 'faq-ore-emigration',
    question: 'Co dzieje się z rudą na emigrującej łodzi?',
    answer:
      'Przepada razem z łodzią, chyba że konkretny efekt wyraźnie stanowi inaczej.',
    requiredModuleIds: ['base'],
  },
  {
    id: 'faq-mountain-order',
    question: 'Czy przy akcji gór mogę wybrać dowolny zasób z paska wzgórz?',
    answer:
      'Nie. Bierzesz kolejną wskazaną liczbę elementów od właściwej strony paska. Nie wybierasz symboli ze środka.',
    requiredModuleIds: ['base'],
    keywords: ['góry', 'wzgórza'],
  },
  {
    id: 'faq-feast-return',
    question: 'Czy żywność z biesiady zostaje na stole do następnej rundy?',
    answer:
      'Nie. Dobra wykorzystane do biesiady wracają do zasobów ogólnych. Za niezakryte pola płacisz karę z planszy.',
    requiredModuleIds: ['base'],
    keywords: ['biesiada', 'uczta'],
  },
  {
    id: 'faq-pigs',
    question: 'Czy świnie mają stronę ciężarną?',
    answer:
      'Nie. Jeżeli w fazie rozmnażania masz co najmniej 2 świnie, po prostu otrzymujesz 1 nową świnię.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    id: 'faq-mares',
    question: 'Jak rozmnażają się klacze?',
    answer:
      'Tak samo jak owce i krowy: używają strony ciężarnej i potrzebują odpowiedniej liczby zwierząt danego rodzaju. Jeden krok na fazę — bez ciąży i porodu naraz.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    id: 'faq-fifth-column-workers',
    question: 'Co z niewykorzystanymi wikingami po akcji z 5. kolumny?',
    answer:
      'Nie możesz ich już użyć w tej rundzie. Akcja z 5. kolumny oznacza natychmiastowe zakończenie twojego udziału w fazie akcji.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    id: 'faq-fifth-column-card',
    question: 'Kiedy 5. kolumna pozwala zagrać pomocnika?',
    answer:
      'Gdy umieścisz na jej polu 2 wikingów. Przy użyciu 1 wikinga otrzymujesz tylko efekt pola.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    id: 'faq-craft-shed-building',
    question: 'Czy szopę rzemieślniczą mam od początku?',
    answer:
      'Masz jej żeton, ale nie jest zbudowana. Możesz ją zbudować zamiast zwykłej szopy, gdy akcja daje możliwość budowy szopy — raz w partii.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    id: 'faq-craft-shed-house',
    question: 'Czy szopa rzemieślnicza jest domem?',
    answer:
      'Nie. Jest szopą, ale nie domem. Ma to znaczenie dla efektów kart.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    id: 'faq-craft-shed-ship-points',
    question: 'Czy liczę punkty z łodzi leżącej na szopie rzemieślniczej?',
    answer:
      'Nie. Punkty nadrukowane na łodzi lub zwierzęciu umieszczonym na szopie nie są liczone osobno.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    id: 'faq-robbery-raid',
    question: 'Czy karta działająca podczas Najazdu działa też podczas Grabieży?',
    answer:
      'Nie, chyba że sama karta albo oficjalne ujednolicenie wyraźnie to potwierdza. Grabież jest osobną akcją.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    id: 'faq-small-emigration-card',
    question: 'Czy efekt dotyczący emigracji obejmuje małą emigrację?',
    answer:
      'Nie automatycznie. Mała emigracja jest odrębnym efektem; karta musi ją wyraźnie obejmować albo znajdować się w tabeli ujednolicenia.',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    id: 'faq-vp-token',
    question: 'Czy mogę odrzucić dowolnego pomocnika po żeton PZ?',
    answer:
      'Możesz to zrobić tylko wtedy, gdy masz właśnie możliwość zagrania karty pomocnika. Zamiast zagrania odrzucasz kartę i bierzesz najwyższy dostępny żeton (4, potem 3, potem 2).',
    requiredModuleIds: ['base', 'norwegians'],
  },
  {
    id: 'faq-first-player',
    question: 'Kto zostaje pierwszym graczem w następnej rundzie?',
    answer:
      'Gracz, który w fazie akcji spasuje jako pierwszy, otrzymuje znacznik pierwszego gracza i zaczyna fazę akcji w następnej rundzie. Pozostali mogą jeszcze wykonywać akcje po jego pasie.',
    requiredModuleIds: ['base'],
    keywords: ['pierwszy gracz', 'pas', 'znacznik'],
  },
  {
    id: 'faq-column-cost',
    question: 'Czy mogę położyć mniej wikingów niż wymaga kolumna?',
    answer:
      'Nie. Kolumna określa dokładny koszt: pole w trzeciej kolumnie wymaga trzech dostępnych wikingów naraz. Brak pełnej liczby oznacza, że nie możesz wybrać tego pola.',
    requiredModuleIds: ['base'],
    keywords: ['kolumna', 'wikingowie', 'koszt'],
  },
  {
    id: 'faq-feast-length',
    question: 'Skąd wiem, ile pól stołu muszę zakryć w biesiadzie?',
    answer:
      'Długość stołu wynika z planszy stołu biesiadnego oraz liczby aktywnych wikingów i rundy — odczytaj wymagany odcinek z komponentu. Za każde niezakryte wymagane pole płacisz karę z planszy; użyte dobra wracają do zasobów.',
    requiredModuleIds: ['base'],
    keywords: ['biesiada', 'stół', 'kara'],
  },
  {
    id: 'faq-solo-block',
    question: 'Kiedy zdejmuję wikingów blokujących pola w solo?',
    answer:
      'Wikingowie z jednej rundy blokują kolejną rundę. Zdejmujesz ich po rozegraniu rundy drugim zestawem, zgodnie z naprzemiennym rytmem wariantu.',
    requiredModuleIds: ['base', 'solo'],
  },
] as const;
